
import Vue from "vue";
import { Dossier } from "@/models/dossier";
import AppLabel from "@/components/InfoInput.vue";

export default Vue.extend({
	props: {
		value: {
			type: Object as ()=>Dossier,
			required: true
		}
	},
	components: {
		AppLabel
	}
});
